// React
import React, { useRef } from "react";
// Monaco (Editor)
import Editor from "@monaco-editor/react";
// Translation
import i18n from "i18next";

////////////////////////////////
//           Props            //
////////////////////////////////

interface CodeEditorProps {
  content: string;
  setContent: any;
  setErrors?: (markers: any[]) => void;
  height?: string;
}

const CodeEditor: React.FC<CodeEditorProps> = ({ content, setContent, setErrors, height = "75vh" }) => {

  /////////////////////////////////////
  //      Constants / ValueSet       //
  /////////////////////////////////////

  const editorRef = useRef();

  ////////////////////////////////
  //           Actions          //
  ////////////////////////////////

  const onMount = (editor: any) => {
    editorRef.current = editor;
  };

  //////////////////////////////
  //          Content         //
  //////////////////////////////

  return (
    <>
      <Editor
        height={height}
        theme="vs-light"
        defaultLanguage="json"
        defaultValue={i18n.t("text.editortext")}
        value={content}
        onMount={onMount}
        onChange={(value: any) => setContent(value)}
        onValidate={(markers: any[]) => setErrors?.(markers)}
        options={{
          automaticLayout: true,
          // Disable autocomplete
          quickSuggestions: false,
          // Disable suggestions on trigger characters
          suggestOnTriggerCharacters: false,
          // Disable minimap
          minimap: {
            enabled: false,
          },
        }}
      />
    </>
  );
};

export default CodeEditor;
